import { render, staticRenderFns } from "./FormDocuments.vue?vue&type=template&id=17776050&scoped=true&"
import script from "./FormDocuments.vue?vue&type=script&lang=js&"
export * from "./FormDocuments.vue?vue&type=script&lang=js&"
import style0 from "./FormDocuments.vue?vue&type=style&index=0&id=17776050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17776050",
  null
  
)

export default component.exports